import { all } from 'redux-saga/effects';
import { combineReducers } from 'redux';

import * as auth from '../app/modules/Auth/_redux/authRedux';
import { errorsSlice } from '../app/modules/Auth/_redux/errorRedux';

export const rootReducer = combineReducers({
  auth: auth.reducer,
  errors: errorsSlice.reducer,
});

export function* rootSaga() {
  yield all([auth.saga()]);
}
